function isProductionEnvironmentUtil () {
  if (BROWSER) {
    const host = window.location.host || window.location.hostname
    return host.indexOf('www.gymaholic.co') > -1
  }
  return NODE_ENV === 'production'
}

function isStagingEnvironmentUtil () {
  if (BROWSER) {
    const host = window.location.host || window.location.hostname
    return host.indexOf('staging.gymaholic.co') > -1
  }
  return NODE_ENV === 'staging'
}

function getWebsiteUrlEnvironmentUtil () {
  if (BROWSER) {
    return window.location.origin || window.location.host
  }
  if (isProductionEnvironmentUtil()) {
    return 'https://www.gymaholic.co'
  }
  if (isStagingEnvironmentUtil()) {
    return 'https://staging.gymaholic.co'
  }
  return 'https://localhost.co:' + PORT
}

function getApiServiceUrlEnvironmentUtil () {
  // if (isProductionEnvironmentUtil()) {
  return 'https://api.gymaholic.co/1'
  // }
  // if (isStagingEnvironmentUtil()) {
  //   return 'https://api-staging.gymaholic.co/1'
  // }
  // // Handle remote mobile debugging
  // // e.g. 192.168.0.32
  // if (BROWSER && DEVELOPMENT) {
  //   const hostname = window.location.hostname
  //   if (/([0-9]+)+/.test(hostname)) {
  //     return 'https://' + hostname + ':3000/1'
  //   }
  // }
  // return API_ENDPOINT
}

export {
  isProductionEnvironmentUtil,
  getWebsiteUrlEnvironmentUtil,
  getApiServiceUrlEnvironmentUtil
}
